import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import SydLabel from '../../../../commonDesign/SydLabel'
import Switch from '../../../../molecules/Switch'
import DateRangeFilter from './DateRangeFilter'
import HouseholdMultiSelect from './HouseholdMultiSelect'
import UserFilter from './UserFilter'
import { useUserLoginActivityContext } from './UserLoginActivityProvider'

const toolbarStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
  gap: '8px',
  padding: '8px 0'
}

const filterCellStyle = {
  minWidth: '200px'
}

const searchFilterStyle = {
  minWidth: '300px'
}

const controlRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '3px 10px',
  fontSize: 'var(--font-size-sm)'
}

const useStyles = makeStyles((theme) => ({
  filterLabel: {
    display: 'block',
    paddingBottom: '3px',
    fontWeight: theme.typography.weights.bold
  },
  activeMarker: {
    color: 'var(--color-danger-500)',
    fontSize: '16px',
    marginLeft: '3px',
    lineHeight: 1
  }
}))

export default function UserLoginActivityToolbar () {
  const classes = useStyles()
  const {
    filterState,
    searchText,
    selectedHouseholdClientIds,
    dateRange,
    setNeverLoggedIn
  } = useUserLoginActivityContext()

  const handleNeverLoggedInChange = useCallback((e) => {
    setNeverLoggedIn(e.target.checked)
  }, [setNeverLoggedIn])

  const isUserFilterActive = !!searchText?.trim()
  const isHouseholdFilterActive = (selectedHouseholdClientIds?.length ?? 0) > 0
  const isDateRangeFilterActive = !!dateRange?.preset

  return (
    <div style={toolbarStyle}>
      <div style={searchFilterStyle}>
        <label className={classes.filterLabel}>
          User
          {isUserFilterActive && (
            <span className={classes.activeMarker} aria-hidden='true'>*</span>
          )}
        </label>
        <UserFilter />
      </div>
      <div style={filterCellStyle}>
        <label className={classes.filterLabel}>
          Household
          {isHouseholdFilterActive && (
            <span className={classes.activeMarker} aria-hidden='true'>*</span>
          )}
        </label>
        <HouseholdMultiSelect />
      </div>
      <div style={filterCellStyle}>
        <label className={classes.filterLabel}>
          Date range
          {isDateRangeFilterActive && (
            <span className={classes.activeMarker} aria-hidden='true'>*</span>
          )}
        </label>
        <DateRangeFilter />
      </div>
      <SydLabel label='Never logged in' style={{ marginBottom: 0 }}>
        <div style={controlRowStyle}>
          <Switch
            checked={!!filterState.neverLoggedIn}
            onChange={handleNeverLoggedInChange}
          />
        </div>
      </SydLabel>
    </div>
  )
}
